import { Map, List, fromJS } from 'immutable'
import humps from 'humps'

import { createReducer } from '_utils/redux'
import {
  WEBSOCKET_VIDEO_ASSIGNMENT_STARTING,
  WEBSOCKET_VIDEO_ASSIGNMENT_STARTED,
  WEBSOCKET_VIDEO_ASSIGNMENT_ENDED,
} from '_modules/websocket/actions'
import { START_CALL } from '_modules/class/actions'

import {
  GET_SUMMARY,
  GET_UPCOMING_GOALS,
  GET_PEOPLE_YOU_MAY_KNOW,
  GET_ANNOUNCEMENTS,
  GET_UPCOMING_CALL,
} from './actions'

const INITIAL_STATE = Map({
  summary: Map({
    takingCourses: null,
    totalAssignments: null,
    completedAssignments: null,
    upcomingAssignments: List(),
    // upcomingCalls is deprecated, use root upcomingCall instead
    upcomingCalls: List(),
  }),
  upcomingGoals: List(),
  peopleYouMayKnow: List(),
  announcements: List(),
  upcomingCall: null,
})

const dashboard = createReducer(INITIAL_STATE, {
  [GET_SUMMARY.FULFILLED]: (state, { payload }) =>
    state.set('summary', Map(humps.camelizeKeys(payload))),

  [GET_UPCOMING_CALL.FULFILLED]: (state, { payload }) => {
    const camelizedPayload = humps.camelizeKeys(payload)

    return state.set(
      'upcomingCall',
      camelizedPayload.upcomingCall ? Map(camelizedPayload.upcomingCall) : null
    )
  },

  [GET_UPCOMING_GOALS.FULFILLED]: (state, { payload }) =>
    state.set('upcomingGoals', List(humps.camelizeKeys(payload))),

  [GET_PEOPLE_YOU_MAY_KNOW.FULFILLED]: (state, { payload }) =>
    state.set('peopleYouMayKnow', List(humps.camelizeKeys(payload))),

  [GET_ANNOUNCEMENTS.FULFILLED]: (state, { payload }) => {
    const formattedPayload = fromJS(humps.camelizeKeys(payload.results))
    return state.set('announcements', formattedPayload)
  },

  [WEBSOCKET_VIDEO_ASSIGNMENT_STARTING]: (state, { payload }) => {
    const { classId, leaderId, meetingJoinUrl, meetingStartTime, meetingId } = payload

    const upcomingCall = state.get('upcomingCall')

    let nextCallBase = {}
    let existingMeeting = {}

    if (upcomingCall && upcomingCall.toJS) {
      nextCallBase = upcomingCall.toJS()

      if (upcomingCall.get('meeting') && upcomingCall.get('meeting').toJS) {
        existingMeeting = upcomingCall.get('meeting').toJS()
      }
    }

    const nextCall = {
      ...nextCallBase,
      classId,
      leaderId,
      meeting: {
        ...existingMeeting,
        startTime: meetingStartTime,
        id: meetingId,
        joinUrl: meetingJoinUrl,
      },
      joinUrl: meetingJoinUrl,
      startTime: meetingStartTime,
    }

    return state.set('upcomingCall', Map(nextCall))
  },

  [WEBSOCKET_VIDEO_ASSIGNMENT_STARTED]: (state, { payload }) => {
    const { classId, leaderId, meetingJoinUrl, meetingStartTime, meetingId } = payload

    const upcomingCall = state.get('upcomingCall')

    if (upcomingCall && upcomingCall.get('classId') === classId) {
      return state.setIn(['upcomingCall', 'meeting', 'started'], true)
    }

    const nextCall = Map({
      classId,
      leaderId,
      meeting: Map({
        startTime: meetingStartTime,
        id: meetingId,
        joinUrl: meetingJoinUrl,
        started: true,
      }),
      joinUrl: meetingJoinUrl,
      startTime: meetingStartTime,
    })

    return state.set('upcomingCall', nextCall)
  },

  [WEBSOCKET_VIDEO_ASSIGNMENT_ENDED]: (state, { payload }) => {
    const { classId } = payload

    const upcomingCall = state.get('upcomingCall')

    if (upcomingCall && upcomingCall.get('classId') === classId) {
      return state.set(['upcomingCall', 'meeting', 'ended'], true)
    }

    return state
  },

  [START_CALL.FULFILLED]: state => {
    const upcomingCall = state.get('upcomingCall')

    if (upcomingCall) {
      return state.set(['upcomingCall', 'meeting', 'started'], true)
    }

    return state
  },
})

export default dashboard
